<template>
    <div class="inner-container">
        <div class="table-container">
            <b-table
                :fields="tableFields"
                :items="goodsData"
                responsive="true"
                bordered
                head-variant="light"
                sticky-header="true"
                no-border-collapse
            >
                <template #head(more)>
                    <div class="text-center">
                        <i
                            :title="getCommonText('del_selected')"
                            class="icon icon-close table-all-remove"
                            @click="
                                deleteItem(
                                    `${
                                        selectAllGoods
                                            ? getDecText('del_all_recs')
                                            : getDecText('del_selected_recs')
                                    }`
                                )
                            "
                        />
                    </div>
                </template>
                <template #top-row="data">
                    <td></td>
                    <td class="td-numbering table-success text-center">1</td>
                    <td class="td-numbering table-danger text-center">2</td>
                    <td class="td-numbering table-info text-center">3</td>
                    <td class="td-numbering table-primary text-center">4</td>
                    <td class="td-numbering table-warning text-center">5</td>
                    <td></td>
                </template>
                <template #head(action)>
                    <div class="text-center">
                        <b-form-checkbox
                            v-model="selectAllGoods"
                            @change="
                                (e) => $emit('setIsAllDelete', e, goodsData)
                            "
                            :value="true"
                            :unchecked-value="false"
                        />
                    </div>
                </template>

                <template #cell(action)="data">
                    <b-form-checkbox
                        v-model="data.item.itemToDelete"
                        @input="
                            (e) => {
                                if (!e) selectAllGoods = false;
                            }
                        "
                        :value="true"
                        :unchecked-value="false"
                    />
                </template>
                <template #cell(bc_goal)="data">
                    <div class="column-width-100">
                        <multiselect
                            v-if="variantAttribute && data.item.id < 0"
                            style="max-width:750px;"
                            v-model="data.item.curr_bc_goal"
                            :label="`name_${lng}`"
                            :placeholder="getFormText('select_bc_goal')"
                            :options="dictBcGlobalActualDisabled"
                            :searchable="true"
                            :allow-empty="false"
                            :show-labels="false"
                            :title="data.item.curr_bc_goal ? data.item.curr_bc_goal[`name_${lng}`] : ''"
                            @input="onCodeChanged(data.item)"
                        >
                        </multiselect>
                        <div v-else>
                            {{dictBcGlobalNames[data.item.bc_goal] && dictBcGlobalNames[data.item.bc_goal][`name_${lng}`] }}
                        </div>
                        <p
                            class="goods-form-val-msg"
                            v-if="
                                variantAttribute &&
                                !data.item.curr_bc_goal
                            "
                        >
                            {{ getCommonText("must_be_filled") }}
                        </p>
                    </div>
                </template>
                <template #cell(amount)="data">
                    <b-form-input
                        v-if="variantAttribute && data.item.curr_bc_goal"
                        class="text-right number-input-width"
                        :value="data.item.amount"
                        @change="(v) => inputFixed(data.item, 'amount', v, 2)"
                        @keyup.enter.exact="keyup13"
                        @keypress="keyPress($event, '^\\d*\\.?\\d{0,9}$')"
                    >
                    </b-form-input>
                    <div v-else class="text-right">
                        {{ $n(data.value) }}
                    </div>
                    <p
                        class="goods-form-val-msg"
                        v-if="
                            variantAttribute &&
                            !data.item.amount &&
                            data.item.curr_bc_goal
                        "
                    >
                        {{ getCommonText("positive") }}
                    </p>
                </template>
                <template #cell(cost)="data">
                    <b-form-input
                        v-if="variantAttribute && data.item.curr_bc_goal"
                        class="text-right number-input-width"
                        :value="data.item.cost"
                        @change="(v) => inputFixed(data.item, 'cost', v, 2)"
                        @keyup.enter.exact="keyup13"
                        @keypress="keyPress($event, '^\\d*\\.?\\d{0,9}$')"
                    >
                    </b-form-input>
                    <div v-else class="text-right">
                        {{ $n(data.value) }}
                    </div>
                    <p
                        class="goods-form-val-msg"
                        v-if="
                            variantAttribute &&
                            !data.item.cost &&
                            data.item.curr_bc_goal
                        "
                    >
                        {{ getCommonText("positive") }}
                    </p>
                </template>
                <template #cell(total)="data">
                    <div class="text-right">{{ $n(data.value) }}</div>
                </template>
                <template #cell(files)="data">
                    <span
                        class="blue pointer underline"
                        @click="onFilesClick(data.item)"
                        >({{
                            data.item.file_hash
                                ? data.item.file_hash.split(";").length
                                : 0
                        }})</span
                    >
                </template>
                <template #cell(more)="data">
                    <i
                        class="icon icon-clear table-remove"
                        :disabled="isLoad"
                        v-if="variantAttribute"
                        @click="
                            deleteItem(
                                `${getDecText('del_curr_rec')}`,
                                data.item,
                                data.index
                            )
                        "
                    ></i>
                </template>

                <template #bottom-row="data">
                    <td class="text-left" colspan="2">
                        {{ getCommonText("total") }}
                    </td>
                    <td class="text-right">{{ $n(totalAmount) }}</td>
                    <td class="text-right">{{ $n(totalCost) }}</td>
                    <td class="text-right">{{ $n(total) }}</td>
                    <td colspan="2"></td>
                </template>
            </b-table>
            <modal-files-management
                ref="modalFilesManagement"
                :allFiles="allFiles"
                :variantAttribute="variantAttribute"
                @showFileUploadModal="showFileUploadModal"
                @setNewFileHash="setNewFileHash"
                @triggDownloadFile="triggDownloadFile"
                @triggDownloadAllFiles="triggDownloadAllFiles"
            ></modal-files-management>
        </div>
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import ModalFilesManagement from "./modal-files-management.vue";
import BpI18nHandlerMixin from "../mixins/bp-i18n-handler-mixin";

export default {
    name: "FormTemplate10",
    components: {
        ModalFilesManagement,
    },
    mixins: [BpI18nHandlerMixin],
    props: {
        goodsData: Array,
        variantAttribute: Boolean,
        currCategory: Object,
        lng: String,
        showFileUploadModal: Function,
        triggDownloadFile: Function,
        triggDownloadAllFiles: Function,
        allFiles: Array,
        isLoad: Boolean,
        dictBcGlobal: Array,
        dictBcGlobalActualDisabled: Array,
        safeDecimal: Function,
    },

    data() {
        return {
            selectAllGoods: false
        };
    },
    methods: {
        addItem() {
            if (!this.ifAllFieldsFilled()) return;
            const item = { id: new Date() * -1 };
            this.$set(item, "isNew", true);
            this.$set(item, "rowToSave", true);
            this.$set(item, "curr_bc_goal", null);
            this.$set(item, "bc_goal", null);
            this.$set(item, "amount", 0);
            this.$set(item, "cost", 0);
            this.$set(item, "itemToDelete", false);
            this.$set(item, "isHasDouble", false);
            this.$set(item, "isDataValid", false);
            this.$set(item, "file_hash", null);
            this.$set(item, "category_id", this.currCategory.category_id);
            this.$emit("addGetParams", item)
            this.goodsData.push(item);
        }, // добавление записи в таблицу

        ifAllFieldsFilled() {
            const emptyField = this.goodsData.some(
                (item) => !item.bc_goal || !item.amount || !item.cost
            );
            return !emptyField;
        },

        makeToast(variant = null, title, msg) {
            this.$bvToast.toast(msg, {
                title: title,
                variant: variant,
                solid: true,
            });
        },

        onDataChanged(item) {
            this.$set(item, "rowToSave", true);
            this.setIsDataValid(item);
        }, // переключения тригера при изменении данных товаров

        inputFixed(item, field, value, digit) {
            this.$set(item, field, value);
            this.$nextTick(() => {
                let newVal = parseFloat(value)
                    ? parseFloat(parseFloat(value).toFixed(digit))
                    : 0;
                if (newVal < 0) newVal = newVal * -1;
                this.$set(item, field, newVal);
                this.onDataChanged(item);
            });
        }, // форматирует введенное значение до digit цифр после запятой

        keyPress: function (event, pattern) {
            const regex = new RegExp(pattern);
            const key = String.fromCharCode(
                !event.charCode ? event.which : event.charCode
            );
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, // вводит по заданному паттерну

        keyup13: function (event) {
            event.preventDefault();
            // Isolate the node that we're after
            const currentNode = event.target;
            // find all tab-able elements
            const allElements = document.querySelectorAll("input"); // area, object, select, [contenteditable]
            // Find the current tab index.
            const currentIndex = [...allElements].findIndex((el) =>
                currentNode.isEqualNode(el)
            );
            // select/focus the following element
            const targetIndex = (currentIndex + 1) % allElements.length;
            if (targetIndex < allElements.length) {
                allElements[targetIndex].select();
            }
        }, // enter работает как tab

        deleteItem(msg, row = false, index = false) {
            if (
                !this.variantAttribute ||
                (!row &&
                    this.goodsData.findIndex((itm) => itm.itemToDelete) === -1)
            )
                return;
            let deletingRow = null;
            this.$bvModal
                .msgBoxConfirm(`${msg}...`, {
                    title: this.getCommonText("confirm"),
                    size: "lg",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: this.getCommonText("yes"),
                    cancelTitle: this.getCommonText("cancel"),
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        if (row) {
                            if ((!row.id || row.id < 0) && row.rowToSave) {
                                this.goodsData.splice(index, 1);
                            } else {
                                this.$emit("deleteRows", [row], "decodes");
                                deletingRow = this.goodsData.splice(index, 1);
                            }
                        } else {
                            const existingRowsToDel = [];
                            for (
                                let i = this.goodsData.length - 1;
                                i >= 0;
                                i--
                            ) {
                                if (this.goodsData[i].itemToDelete) {
                                    const rowId = this.goodsData[i].id;
                                    if (rowId >= 0) {
                                        existingRowsToDel.push(
                                            this.goodsData[i]
                                        );
                                    }
                                    this.goodsData.splice(i, 1);
                                }
                            }
                            if (existingRowsToDel.length) {
                                this.$emit(
                                    "deleteRows",
                                    existingRowsToDel,
                                    "decodes"
                                );
                            }
                            this.selectAllGoods = false;
                        }
                        this.$emit('disableSelectedBcGlobal');
                    }
                })
                .catch((error) => {
                    if (deletingRow)
                        this.goodsData = [
                            ...this.goodsData,
                            ...deletingRow,
                        ].sort((a, b) => a.id - b.id);
                    this.makeToast(
                        "danger",
                        this.getErrText("on_del"),
                        error.toString()
                    );
                });
        }, // удаление записи

        onFilesClick(item) {
            this.allFiles.forEach((item) => {
                if (item.new_file) this.$set(item, "new_file", false);
            });
            this.$refs.modalFilesManagement.showModal(item);
        },

        setNewFileHash(id, codes) {
            for (const good of this.goodsData) {
                if (good.id === id) {
                    this.$set(good, "file_hash", codes);
                    this.onDataChanged(good);
                    break;
                }
            }
        },

        onCodeChanged(item) {
            this.setBcGlobalCode(item);
            this.$emit('disableSelectedBcGlobal');
            this.onDataChanged(item);
        },

        setBcGlobalCode(item) {
            if ('curr_bc_goal' in item) {
                this.$set(item, 'bc_goal', item.curr_bc_goal.code)
            }
        },
        
        setIsDataValid(row) {
            if (row.bc_goal && row.amount && row.cost) {
                this.$set(row, "isDataValid", true);
            } else {
                this.$set(row, "isDataValid", false);
            }
        },
    },
    computed: {
        getFormText() {
            return this.setFormText("forms_v2_common.");
        },

        
        dictBcGlobalNames() {
            return this.dictBcGlobal.reduce((acc, item) => {
                        acc[item.code] = {name_ru: item.name_ru, name_kk: item.name_kk};
                        return acc;
                    }, {});
        },

        total() {
            const total = this.goodsData.reduce(
                (acc, item) => acc + item.total,
                0
            );
            return total;
        },

        totalAmount() {
            const total = this.goodsData.reduce(
                (acc, item) => acc + item.amount,
                0
            );
            return total;
        },

        totalCost() {
            if (!this.totalAmount) return 0;
            const total = this.safeDecimal(this.total);
            const totalAmount = this.safeDecimal(this.totalAmount);
            const totalCost = total.mul(1000).div(totalAmount).toDecimalPlaces(2);
            return totalCost.toNumber();
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: "action",
                        label: " ",
                    },
                    {
                        key: "bc_goal",
                        label: this.getCommonText("name"),
                    },
                    {
                        key: "amount",
                        label: this.getFormText("amount"),
                    },
                    {
                        key: "cost",
                        label: this.getFormText("one_item_cost"),
                    },
                    {
                        key: "total",
                        label: this.getFormText("total_cost_cols"),
                    },
                    {
                        key: "files",
                        label: this.getCommonText("files"),
                    },
                    {
                        key: "more",
                        label: "",
                    },
                ];
            }
            return [];
        },
    },
};
</script>

<style scoped>

.goods-form-val-msg {
    font-size: 0.5rem;
    font-style: italic;
    color: red;
}
</style>
